import { z } from 'zod';
import type { AccountingTreatment } from '../types.js';

export const ACCOUNTING_TREATMENTS = [
  'UNREVIEWED',
  'HELD_522',
  'REQUIRES_EC',
] as const satisfies readonly AccountingTreatment[];

export const UpdateAssetAccountingRequestSchema = z
  .object({
    treatment: z.enum(ACCOUNTING_TREATMENTS),
    reason: z.string().trim().min(10).max(500),
    accountingAssetId: z.number().int().positive().nullable().optional(),
    confirmOneToOne: z.literal(true).optional(),
  })
  .strict();

export type UpdateAssetAccountingRequest = z.infer<typeof UpdateAssetAccountingRequestSchema>;

export function isNewOneToOneAccountingAssetMapping(
  assetId: number,
  oldAccountingAssetId: number | null,
  requestedAccountingAssetId: number | null | undefined,
): boolean {
  return (
    requestedAccountingAssetId !== undefined &&
    requestedAccountingAssetId !== null &&
    requestedAccountingAssetId !== assetId &&
    requestedAccountingAssetId !== oldAccountingAssetId
  );
}
